/*
 * /welcome (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Alert,
	ButtonLink,
	Container,
	Divider,
	Page,
	PageHeader,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"

export const Route = createFileRoute("/welcome")({ component: WelcomePage })

function WelcomePage() {
	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Welcome to Psychology!"}
					left={{
						href: "/",
						label: "Home",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div
					className={
						"flex size-full flex-col items-center justify-center gap-3"
					}
				>
					<h4 className={"p-1 text-lg"}>
						We're here to help you with your mental health or journey of
						self-discovery.
					</h4>
					<div
						className={"flex flex-col items-center justify-center gap-3 py-6"}
					>
						<ButtonLink to={"/setup/user"} variant={"default"}>
							Ready to make the first step?
						</ButtonLink>
					</div>
				</div>
				<div className={"p-2"}>
					<Alert title={"Disclaimer"} variant={"warning"}>
						Timeprox Psychology does not replace professional medical advice or
						counselling. If you are in crisis, please contact a crisis hotline
						or emergency services.
					</Alert>
				</div>
			</Container>
		</Page>
	)
}
